import React from 'react';
import {Link, NavLink} from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const noCode = () => {
    return (
        <React.Fragment>
            <div className="container col-5 mt-4" /*style={{ width: "100%", maxWidth: "400px", margin: "0 auto" }}*/>
                <NavLink to="/registercode" className="no-decoration">
                    <button className="btn btn-lg btn-primary btn-block text-white text-center"><FormattedMessage id="nocode-btn"/></button>
                </NavLink>
            </div>
            <div className="row mt-5 col-12">
                <div className="col-6">
                <NavLink to="/indicators" className="list-group-item list-group-item-action waves-effect"
                         activeClassName="active">
                    <i className="fas fa-money-bill-alt mr-3"/>Indicadores Gerais
                </NavLink>
                </div>
                <div className="col-6">
                <NavLink to="/personal_indicators" className="list-group-item list-group-item-action waves-effect"
                         activeClassName="active">
                    <i className="fas fa-money-bill-alt mr-3"/>Indicadores Pessoais
                </NavLink>
                </div>
            </div>
        </React.Fragment>

    )
}

export default noCode;



// WEBPACK FOOTER //
// ./src/components/NoCode.js